import { Component, OnInit, Output, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { APP_CONFIG, AppConfig } from 'src/app/app-config';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

  //Event Variables
  @Output() RolesChanged = new EventEmitter<string>();

  UserProfileStatus: boolean = false;
  PembayarCukaiStatus: boolean = false;
  IntegrasiStatus: boolean = false;
  PenyenggaraanStatus: boolean = false;
  BantuanSistemStatus: boolean = false;
  
  // Config property for HTML access
  integrasiCkmTitle: string = '';
  showEWHT!: boolean;
  showEOT!: boolean;

  constructor(
    private router: Router,
    @Inject(APP_CONFIG) private config: AppConfig
    ) {
      this.integrasiCkmTitle = config.sectionTitles.integrasiCkm;
    this.showEWHT = config.features.showEWHT;
    this.showEOT = config.features.showEOT;
    }

  ngOnInit(): void {
  }

  SideContentView(Type: any) {
    switch (Type) {
      case "UserProfile":
        this.UserProfileStatus = !this.UserProfileStatus;
        this.PembayarCukaiStatus = false;
        this.IntegrasiStatus = false;
        this.PenyenggaraanStatus = false;
        this.BantuanSistemStatus = false;
        break;
      case "PembayarCukai":
        this.UserProfileStatus = false;
        this.PembayarCukaiStatus = !this.PembayarCukaiStatus;
        this.IntegrasiStatus = false;
        this.PenyenggaraanStatus = false;
        this.BantuanSistemStatus = false;
        break;
      case "Integrasi":
        this.UserProfileStatus = false;
        this.PembayarCukaiStatus = false;
        this.IntegrasiStatus = !this.IntegrasiStatus;
        this.PenyenggaraanStatus = false;
        this.BantuanSistemStatus = false;
        break;
      case "Penyenggaraan":
        this.UserProfileStatus = false;
        this.PembayarCukaiStatus = false;
        this.IntegrasiStatus = false;
        this.PenyenggaraanStatus = !this.PenyenggaraanStatus;
        this.BantuanSistemStatus = false;
      break;
      case "BantuanSistem":
        this.UserProfileStatus = false;
        this.PembayarCukaiStatus = false;
        this.IntegrasiStatus = false;
        this.PenyenggaraanStatus = false;
        this.BantuanSistemStatus = !this.BantuanSistemStatus;
        break;
      default:
        this.UserProfileStatus = false;
        this.PembayarCukaiStatus = false;
        this.IntegrasiStatus = false;
        this.PenyenggaraanStatus = false;
        this.BantuanSistemStatus = false;
        break;
    }
  }
  onClickedOutside(e: Event) {
    this.UserProfileStatus = false;
    this.PembayarCukaiStatus = false;
    this.IntegrasiStatus = false;
    this.PenyenggaraanStatus = false;
    this.BantuanSistemStatus = false;
  }
  URLClicked() {
    this.UserProfileStatus = false;
    this.PembayarCukaiStatus = false;
    this.IntegrasiStatus = false;
    this.PenyenggaraanStatus = false;
    this.BantuanSistemStatus = false;
  }
  ChangeRolesFromChild(FirmID: any) {
    this.RolesChanged.emit(FirmID);
  }

 
}
